import { useMemo } from 'react';
import { UiConfigType } from '@superset-ui/embedded-sdk';

import { useApiContext } from '../api';
import { SupersetContextType } from './types';
import { SupersetContext } from './superset-context';

interface SupersetProviderProps {
  children: React.ReactNode;
  supersetDomain: string;
  authority: string;
  defaultConfig?: UiConfigType;
}

export function SupersetProvider({
  children,
  supersetDomain,
  authority,
  defaultConfig,
}: SupersetProviderProps) {
  const axios = useApiContext();

  const supersetConfig = useMemo<SupersetContextType>(
    () => ({
      supersetDomain,
      fetchGuestToken: async (dashboardId: string) => {
        const response = await axios.post(`${authority}/api/superset/guest-token`, {
          dashboardId,
        });
        return response.data.token;
      },
      defaultConfig: defaultConfig || {
        hideTitle: true,
        filters: {
          expanded: true,
        },
      },
    }),
    [supersetDomain, defaultConfig, axios, authority]
  );

  return <SupersetContext.Provider value={supersetConfig}>{children}</SupersetContext.Provider>;
}
